import { useAgentDetails } from '../../../agent/detail/hooks/useAgentDetails.js';

import { useFormikEffect } from './useFormikEffect';

export const useAgentPrefetching = (name) => {
    const { prefetch } = useAgentDetails();

    useFormikEffect(prefetch, name);
};
